module.exports = __webpack_public_path__ + "static/media/CSK-horiz-desktop-hover@2x.c202f08f.png";